export default [
    {
        path: '/best-places',
        name: 'best-places',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/BestPlaces.vue')
    }
]
